/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_CronInputs */

const cs_field_cron = /** @type {(inputs: Field_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron výraz`)
};

const en_field_cron = /** @type {(inputs: Field_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron expression`)
};

/**
* | output |
* | --- |
* | "Cron expression" |
*
* @param {Field_CronInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_cron = /** @type {((inputs?: Field_CronInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_CronInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_cron(inputs)
	return cs_field_cron(inputs)
});